import Vue from 'vue'
import App from './App.vue'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import { createProvider } from './vue-apollo'
import moment from 'moment'

Vue.config.productionTip = false
import axios from 'axios';
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)


import _ from 'lodash';
Object.defineProperty(Vue.prototype, '$_', { value: _ });

moment.locale('en-GB');

Vue.filter('formatDate', function(value, format) {
  if(!format){
    format = 'ddd, D MMMM, YYYY'
  }

  if (value) {
    return moment(String(value)).format(format)
  }
});

Vue.filter('prettyBytes', function (num) {
  if (typeof num !== 'number' || isNaN(num)) {
    throw new TypeError('Expected a number');
  }

  var exponent;
  var unit;
  var neg = num < 0;
  var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  if (neg) {
    num = -num;
  }

  if (num < 1) {
    return (neg ? '-' : '') + num + ' B';
  }

  exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
  unit = units[exponent];

  return (neg ? '-' : '') + num + ' ' + unit;
});

Vue.filter('toCurrency', function (value) {

  if (typeof value == "string") {
     value = parseInt(value)
  }
  var formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});


Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdi'
})

new Vue({
  store,
  vuetify,
  router,
  apolloProvider: createProvider(),
  render: h => h(App),
  created: function () {
    // `this` points to the vm instance
    this.$store.dispatch('auth/checkLogin')
    console.log('Authed: ' + this.$store.getters["auth/isAuthenticated"])
  }
}).$mount('#app')
